export const debounce = (fn, wait) => {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
}

/**
 * Returns an object with the measure unit and length
 * @param {string} string
 * @returns Object
 */
export const getMeasureUnitFromString = (string) => {
  let result;
  if (string) {
    const expression = new RegExp(/(-?[\d.]+)([a-z%]*)/g);
    const match = Array.from(string.matchAll(expression));
    result = { value: match[0]?.[1], unit: match[0]?.[2] };
  }
  return result;
}

/**
 * @param {string} id
 * @returns {string}
 */
export const getIdWithoutSuffix = (id) => {
  let idWithoutSuffix = id;
  if (id.indexOf('|') > 0) {
    idWithoutSuffix = id.replaceAll(/\|(\d+)?/g, '');
  }
  return idWithoutSuffix;
}

/**
 * @param {string} id
 * @returns {string}
 */
export const getIndexfromId = (id) => {
  let index = 0;
  let regex = /\|\d+/g;
  let matches = id.match(regex);
  if (matches) {
    index = parseInt(matches[matches.length - 1].replace('|', ''))
  }
  
  return index;
}
